import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { retry } from 'rxjs/operators';
import { ServiceNames } from '../layouts/full/shared/Enums';

const BASE_URL = environment.base_url;

@Injectable({
  providedIn: 'root'
})
export class ChargeService {

  constructor(
    private http: HttpClient
  ) { }

  charge(orderId: string, filePath: string) {

    const url = `${BASE_URL}/charge`;

    return this.http.post(url, {
      scanId: orderId,
      filePath: filePath
    }).pipe(
      retry(2),
      map((resp) => resp)
    )

  }

  chargeDesign(orderId: string, productDesign: ServiceNames) {

    const url = `${BASE_URL}/chargeDesign`;

    return this.http.post(url, {
      scanId: orderId,
      productDesign
    }).pipe(
      retry(2),
      map((resp) => resp)
    )

  }
}
